import * as React from "react";
import "./loaderSpinner.css";

interface LoaderSpinnerProps {
  zoom?: number,
}

/**
 * Kleiner grauer Button, der aktuell noch rot ist
 */
export const LoaderSpinner: React.FC<LoaderSpinnerProps> = ({ zoom = 1 }) => {
  return <div style={{zoom: zoom}} className="lds-roller">
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
  </div>
};
